module.exports = __webpack_public_path__ + "assets/images/template-3.f6ff4e40610e91c6eb62f812730daaab.png";